const getPlayerPrimaryStats = (playerPosition: string, seasonStats) => {
  return [
    {
      label: 'moment.seasonStatistics.gamesPlayed',
      value: seasonStats?.gamesPlayed,
    },
    {
      label: 'moment.seasonStatistics.goals',
      value: seasonStats?.goals,
    },
    {
      label: 'moment.seasonStatistics.assists',
      value: seasonStats?.assists,
    },
  ];
};
const getAbsoluteValue = (value, mod) => {
  if (!Number(value) && !Number(mod)) {
    return 0;
  }
  return Math.round((value * 100) / mod);
};

const getCalculatedValue = (value, mod) => {
  if (!Number(value) && !Number(mod)) {
    return 0;
  }
  return Math.round(value / mod);
};

export const getPlayerSecStatistics = (playerPosition: string, seasonStats) => {
  switch (playerPosition?.toLowerCase()) {
    case 'goalkeeper':
      return [
        {
          label: 'moment.seasonStatistics.gamesStarted',
          value: seasonStats?.gamesStarted,
        },
        {
          label: 'moment.seasonStatistics.goalsConceded',
          value: seasonStats?.goalsConceded,
        },
        {
          label: 'moment.seasonStatistics.saves',
          value: seasonStats?.saves,
        },
        {
          label: 'moment.seasonStatistics.penaltiesSaved',
          value: `${seasonStats?.penaltiesSaved}(${getAbsoluteValue(
            seasonStats?.penaltiesSaved,
            seasonStats?.penaltiesSaved + seasonStats?.penaltiesConceded,
          )}%)`,
        },
      ];
    case 'defender':
      return [
        {
          label: 'moment.seasonStatistics.gamesStarted',
          value: seasonStats?.gamesStarted,
        },
        {
          label: 'moment.seasonStatistics.cleanSheets',
          value: seasonStats?.cleanSheets,
        },
        {
          label: 'moment.seasonStatistics.groundDuels',
          value: `${getCalculatedValue(
            seasonStats?.groundDuelsWon,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.groundDuelsWon,
            seasonStats?.totalGroundDuels,
          )}%)`,
        },
        {
          label: 'moment.seasonStatistics.aerialDuels',
          value: `${getCalculatedValue(
            seasonStats?.aerialDuelsWon,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.aerialDuelsWon,
            seasonStats?.totalAerialDuels,
          )}%)`,
        },
        {
          label: 'moment.seasonStatistics.interceptions',
          value: `${getCalculatedValue(
            seasonStats?.interceptions,
            seasonStats?.gamesPlayed,
          )}`,
        },
      ];
    case 'midfielder':
      return [
        {
          label: 'moment.seasonStatistics.gamesStarted',
          value: seasonStats?.gamesStarted,
        },
        {
          label: 'moment.seasonStatistics.chances',
          value: `${getCalculatedValue(
            seasonStats?.keyPasses,
            seasonStats?.gamesPlayed,
          )}`,
        },
        {
          label: 'moment.seasonStatistics.accuratePasses',
          value: `${getCalculatedValue(
            seasonStats?.accuratePasses,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.accuratePasses,
            seasonStats?.totalPasses,
          )}%)`,
        },
        {
          label: 'moment.seasonStatistics.totalShots',
          value: `${getCalculatedValue(
            seasonStats?.totalShots,
            seasonStats?.gamesPlayed,
          )}`,
        },
        {
          label: 'moment.seasonStatistics.duelsWon',
          value: `${getCalculatedValue(
            seasonStats?.duelsWon,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.duelsWon,
            seasonStats?.totalDuels,
          )}%)`,
        },
      ];
    case 'forward':
      return [
        {
          label: 'moment.seasonStatistics.gamesStarted',
          value: seasonStats?.gamesStarted,
        },
        {
          label: 'moment.seasonStatistics.shotsOnTarget',
          value: `${getCalculatedValue(
            seasonStats?.shotsOnTarget,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.shotsOnTarget,
            seasonStats?.totalShots,
          )}%)`,
        },
        {
          label: 'moment.seasonStatistics.minutesPerGoal',
          value: `${getCalculatedValue(
            seasonStats?.totalTimePlayed,
            seasonStats?.goals,
          )}`,
        },
        {
          label: 'moment.seasonStatistics.dribbles',
          value: `${getCalculatedValue(
            seasonStats?.successfulDribbles + seasonStats?.failedDribbles,
            seasonStats?.gamesPlayed,
          )} (${getAbsoluteValue(
            seasonStats?.successfulDribbles,
            seasonStats?.successfulDribbles + seasonStats?.failedDribbles,
          )}%)`,
        },
        {
          label: 'moment.seasonStatistics.keyPasses',
          value: `${getCalculatedValue(
            seasonStats?.keyPasses,
            seasonStats?.gamesPlayed,
          )}`,
        },
      ];
    default:
      return [];
  }
};

export const getPlayerSeasonStats = (play, seasonStats) => ({
  primary: getPlayerPrimaryStats(play?.playerPosition, seasonStats || {}),
  secondary: getPlayerSecStatistics(play?.playerPosition, seasonStats || {}),
});
